/** ResultsMode — LCA / TEA / circularity. Thin wrapper over the existing ResultsPanel. */

import React from 'react';
import ResultsPanel from '../ResultsPanel';
import { useWorkspace } from './WorkspaceContext';

export default function ResultsMode() {
  const {
    project, analysisResults, isAnalyzing, isDemoBuild,
    handleRunLCA, handleRunTEA, handleRunCircularity, handleExportResults, handleTableProjectUpdate,
  } = useWorkspace();

  return (
    <ResultsPanel
      project={project}
      analysisResults={analysisResults}
      isAnalyzing={isAnalyzing}
      isDemoBuild={isDemoBuild}
      onRunLCA={handleRunLCA}
      onRunTEA={handleRunTEA}
      onRunCircularity={handleRunCircularity}
      onExport={handleExportResults}
      onUpdateProject={(p) => handleTableProjectUpdate(p, 'Project updated')}
    />
  );
}
